module.exports = __webpack_public_path__ + "static/media/currenly-location.419dcd37.svg";